import { render, staticRenderFns } from "./TerminalAdsScreensaver.vue?vue&type=template&id=40fb5070&scoped=true"
import script from "./TerminalAdsScreensaver.vue?vue&type=script&lang=js"
export * from "./TerminalAdsScreensaver.vue?vue&type=script&lang=js"
import style0 from "./TerminalAdsScreensaver.vue?vue&type=style&index=0&id=40fb5070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb5070",
  null
  
)

export default component.exports